export enum EJournalSidebarServices {
  experts = 'Advices',
  documents = 'Documents',
  sale = 'GuideSale',
  rent = 'GuideRent',
}
